import { useState, useEffect } from "react";

import { InteractionType } from "@azure/msal-browser";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { b2cPolicies, protectedResources } from "../authConfig";

/**
 * Custom hook to call a web API using bearer token obtained from MSAL
 * @param {PopupRequest} msalRequest
 * @returns
 */
const useFetchWithMsal = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [skip, setSkip] = useState(true);

  const refreshToken = () => {
    instance
      .acquireTokenSilent({
        account: accounts[0],
        scopes: [...protectedResources.api.scopes.read],
        authority: b2cPolicies.authorities.signUpSignIn.authority,
      })
      .then((response) => {
        localStorage.setItem(`token`, response?.accessToken);
        setSkip(false);
      })
      .catch((e) => {
        localStorage.clear();
        let signUpSignInFlowRequest = {
          authority: b2cPolicies.authorities.signUpSignIn.authority,
          scopes: [...protectedResources.api.scopes.read],
        };
        instance
          .loginRedirect(signUpSignInFlowRequest)
          .catch((error) => console.log(error));
      });
  };

  useEffect(() => {
    if (inProgress === "none") {
      refreshToken();
    }
  }, [inProgress]);

  // useEffect(() => {
  //   console.log(result);
  //   if (result) {
  //     localStorage.setItem("token", result?.accessToken);
  //     setSkip(false);
  //   }
  // }, [result]);
  return {
    skip,
  };
};

export default useFetchWithMsal;
